import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner2-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import { Link } from "react-router-dom";
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap";
import { useTranslation } from "react-i18next";
import "./MediationQAPage.scss";

const MediationqaPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">{t("qa_page_header")}</h1>
          <p className="banner-subtitle">{t("qa_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_qa_page_link1")}</Link>
        <span>{t("breadcrumbs_qa_page_span")}</span>
        <Link>{t("breadcrumbs_qa_page_link2")}</Link>
      </Breadcrumbs>
      <main className="mediation-qa-main-container">
        <header className="mediation-qa-header-section">
          <h2 className="mediation-qa-section-title">{t("qa_page_h3")}</h2>
        </header>
        <section className="mediation-qa-content-section">
          <div className="item">
            <Button
              id="toggler"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                marginTop: "1rem",
                backgroundColor: "white",
                textTransform: "uppercase",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question1")}
            </Button>
            <UncontrolledCollapse toggler="#toggler">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question1_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler1"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question2")}
            </Button>
            <UncontrolledCollapse toggler="#toggler1">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question2_text1")}</p>
                  <p className="mb-3">{t("question2_text2")}</p>
                  <p className="mb-3">{t("question2_text3")}</p>
                  <p className="mb-3">{t("question2_text4")}</p>
                  <p className="mb-3">{t("question2_text5")}</p>
                  <p className="mb-3">{t("question2_text6")}</p>
                  <p className="mb-3">{t("question2_text7")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler2"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question3")}
            </Button>
            <UncontrolledCollapse toggler="#toggler2">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question3_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler3"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question4")}
            </Button>
            <UncontrolledCollapse toggler="#toggler3">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question4_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler4"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question5")}
            </Button>
            <UncontrolledCollapse toggler="#toggler4">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question5_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler5"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question6")}
            </Button>
            <UncontrolledCollapse toggler="#toggler5">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question6_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler6"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question7")}
            </Button>
            <UncontrolledCollapse toggler="#toggler6">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question7_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler7"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question8")}
            </Button>
            <UncontrolledCollapse toggler="#toggler7">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question8_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler8"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question9")}
            </Button>
            <UncontrolledCollapse toggler="#toggler8">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question9_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler9"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question10")}
            </Button>
            <UncontrolledCollapse toggler="#toggler9">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question10_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler10"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question11")}
            </Button>
            <UncontrolledCollapse toggler="#toggler10">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question11_text1")}</p>
                  <p className="mb-3">{t("question11_text2")}</p>
                  <p className="mb-3">{t("question11_text3")}</p>
                  <p className="mb-3">{t("question11_text4")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler11"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question12")}
            </Button>
            <UncontrolledCollapse toggler="#toggler11">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question12_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler12"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question13")}
            </Button>
            <UncontrolledCollapse toggler="#toggler12">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question13_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler13"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question14")}
            </Button>
            <UncontrolledCollapse toggler="#toggler13">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question14_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler14"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question15")}
            </Button>
            <UncontrolledCollapse toggler="#toggler14">
              <Card>
                <CardBody>
                  <p className="mb-3">{t("question15_text1")}</p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler15"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                textTransform: "uppercase",
                marginTop: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("question16")}
            </Button>
            <UncontrolledCollapse toggler="#toggler15">
              <Card>
                <CardBody>
                  <p className="mb-3">
                    {t("question16_text1")}{" "}
                    <a href="http://www.doj.gov.hk/eng/public/pdf/2013/cape.pdf">
                      http://www.doj.gov.hk/eng/public/pdf/2013/cape.pdf
                    </a>
                    {t("question16_text1a")}{" "}
                  </p>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
        </section>
      </main>
      <div className="temporary">
        <img id="res-img" src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default MediationqaPage;
